import {
  Box,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  useDisclosure,
} from '@chakra-ui/react';
import { format as formatDate } from 'date-fns';
import { type MouseEvent, useState } from 'react';
import { DayPicker, DayPickerSingleProps } from 'react-day-picker';
import { useFormContext } from 'react-hook-form';

import InputDate from '../input-date';

type SingleDatePickerProps = DayPickerSingleProps & {
  name: string;
  format?: string;
  mode?: 'single';
  isClearable?: boolean;
  clearAriaLabel?: string;
};

export function SingleDatePicker({
  name,
  mode = 'single',
  format = 'dd/MM/yyyy',
  isClearable = false,
  clearAriaLabel = 'Bersihkan tanggal',
}: SingleDatePickerProps) {
  const {
    register,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  const { onOpen, onClose, isOpen } = useDisclosure();
  const [selectedDate, setSelectedDate] = useState<Date>();
  const watchedValue = watch(name) as string | undefined;

  const handleDaySelect = (date: Date | undefined) => {
    setSelectedDate(date);
    if (!date) {
      setValue(name, '');
      onOpen();
    } else {
      setValue(name, formatDate(date, format));
      onClose();
    }
  };

  const handleClear = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedDate(undefined);
    setValue(name, '');
    onClose();
  };

  return (
    <Popover
      placement="bottom-start"
      onClose={onClose}
      isOpen={isOpen}
      onOpen={onOpen}
    >
      <PopoverTrigger>
        <Box flex="1">
          <InputDate
            name={name}
            register={register}
            errors={errors}
            showClearButton={isClearable && Boolean(watchedValue)}
            onClear={handleClear}
            clearAriaLabel={clearAriaLabel}
          />
        </Box>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverBody>
          <DayPicker
            mode={mode}
            selected={selectedDate}
            onSelect={handleDaySelect}
          />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
